import { SearchModel } from "./../../models/search";
import Marionette from "../../../shared/marionette-mustache";
import { AdvancedSearchFieldModel } from "../../../search/models/advanced-search-field";
import {backboneViewProperties} from "../../../decorators/backbone-properties";

const singleTextFieldTemplate = require<string>("../../../search/views/advanced-search/single-text-field.html");
const textAreaTemplate = require<string>("../../../search/views/advanced-search/textarea-field.html");
const yearRangeTemplate = require<string>("../../../search/views/advanced-search/year-range-field.html");

const dom = {
    SEARCH_BOX: "#search-box",
    FORM_FIELD: ".form-field"
};

const template = require<string>("./field-selector-entry.html");

@backboneViewProperties({
    tagName: "li",
    template
})
export class FieldSelectorEntryView extends Marionette.ItemView<AdvancedSearchFieldModel> {

    constructor(options?) {
        super(options);
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        return events;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/field-selector-entry.ts